export default [
  {
    path: '/engagement_letters/:token',
    name: 'public_engagement_letters',
    props: true,
    meta: { title: 'Engagement Letter - Innovation Law Lab Platform' },
    component: _ => import('@/views/public/EngagementLetter.vue'),
  },
]
